import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import { makeStyles } from "@mui/styles";

// MUI
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import { openSnack } from "../../../redux/ducks/snackbar";
import {
  closeAcceptDialog,
  acceptOffer,
  cleanUp,
} from "../../../redux/ducks/offerView";

const AcceptOfferDialog = ({ offer }) => {
  const { open, loading, loaded, error } = useSelector(
    (state) => state.offerView.acceptDialog
  );
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(closeAcceptDialog());
  };

  React.useEffect(() => {
    if (!!loaded) {
      dispatch(openSnack("Angebot wurde erfolgreich angenommen"));
      dispatch(cleanUp(true));
    }
  }, [loaded, dispatch]);
  React.useEffect(() => {
    if (!!error) {
      dispatch(
        openSnack(
          !!error.message
            ? error.message
            : "Es ist ein Fehler aufgetreten. Ihre Anfrage konnte nicht bearbeitet werden",
          "error"
        )
      );
      dispatch(cleanUp(true));
    }
  }, [error, dispatch]);
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{"Sind Sie sicher?"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {
            "Sind Sie sicher, dass Sie dieses Angebot akzeptieren möchten? Damit werden alle anderen Angebote für diesen Auftrag abgelehnt. "
          }
          <Typography sx={{ fontWeight: "Bold" }}>
            Der Auftrag ist hiermit bindend und rechtskräftig
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleClose} color="primary">
          {"Abbrechen"}
        </Button>
        <Button
          disabled={loading}
          onClick={() => {
            dispatch(acceptOffer(offer._id));
          }}
          color="primary"
          autoFocus
        >
          {loading ? <CircularProgress /> : "Angebot Akzeptieren"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AcceptOfferDialog;
